import { Fade, TabContent, TabPane } from 'reactstrap';
import CardLayout from '../Layout/CardLayout';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
interface ITabContainerProps {
  activeTab?: number;
  children: ReactNode;
  tabId?: number;
}
const TabContainer = ({ activeTab, children, tabId }: ITabContainerProps) => {
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  return (
    <TabContent activeTab={activeTab}>
      <TabPane tabId={tabId}>
        <Fade in={activeTab === tabId} timeout={200}>
          <CardLayout isGrid={tableView === 'grid'} cardStyle="mb-4">
            {children}
          </CardLayout>
        </Fade>
      </TabPane>
    </TabContent>
  );
};
export default TabContainer;
